import { connect } from 'react-redux';
import { getShopProductivity } from '../selectors';
import BusinessProductivity from '../components/BusinessProductivity';

const BusinessProductivityContainer = connect(state => ({
  value: Math.round(getShopProductivity(state)),
}))(BusinessProductivity);

export default BusinessProductivityContainer;
